import Request from "@/libraries/request.js";

export default {
  BaseURL: "/permissions",
  async get(url = null) {
    const result = await Request.getAsync(url);
    let data = {};
    if (result.data.status) {
      data = result.data.data;
    }
    return data;
  },

  async get_permissions() {
    let url;
    url = this.BaseURL;
    const data = await this.get(url);
    return data;
  },
  async get_permission(id) {
    let url;
    url = this.BaseURL + "/" + id;
    const data = await this.get(url);
    return data;
  },


  async get_my() {
    let url;
    url = this.BaseURL + "/my";
    const data = await this.get(url);
    return data;
  },

  async get_group_permission() {

  }

};




// WEBPACK FOOTER //
// ./src/model/permission_model.js